import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";
import { TYPES } from "./ModalTypes";

const ConfirmationModal = ({
  visible,
  onHide,
  onConfirm,
  getModalContent,
  localeText,
  loading,
  type,
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      style={{ maxWidth: "600px" }}
      draggable={false}
      modal
      closable={false}
      headerClassName="bg-white"
      footer={
        <div className="flex justify-content-end gap-2 mt-2">
          <Button
            label={localeText("cancel")}
            className="p-button-outlined"
            style={{ backgroundColor: "#0A0D1408", borderColor: "#EBEBEB", color: "#5C5C5C" }}
            onClick={onHide}
            disabled={loading}
            loading={loading}
          />
          <Button
            label={localeText("remove")}
            className={type === TYPES.DANGER ? "p-button-danger" : ""}
            style={{
              backgroundColor: "var(--theme-primary)",
              color: "#fff",
              background: type === TYPES.DANGER ? "#d32f2f" : "var(--theme-primary)",
              border:
                type === TYPES.DANGER ? "1px solid #d32f2f" : "1px solid var(--theme-primary)",
            }}
            onClick={onConfirm}
            disabled={loading}
            loading={loading}
          />
        </div>
      }
    >
      <div flex className="flex justify-content-center" style={{ padding: "4px" }}>
        <i
          className={`pi pi-exclamation-circle text-4xl mb-3 text-center`}
          style={{ color: type === TYPES.DANGER ? "#d32f2f" : "var(--theme-primary)" }}
        ></i>
      </div>

      {getModalContent().title && (
        <p className="m-0 font-semibold text-center mb-2" style={{ color: "var(--theme-text)" }}>
          {getModalContent().title}
        </p>
      )}

      {getModalContent().description && (
        <p className="m-0 text-center" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {getModalContent().description}
        </p>
      )}
    </Dialog>
  );
};

export default ConfirmationModal;
